<script>
  import DataTool from "./Tool.svelte";
  import { Theme, FontsUrban } from "@urbaninstitute/dataviz-components";
</script>

<svelte:options customElement={{tag: "data-tool"}} />

<FontsUrban />
<Theme>
  <DataTool />
</Theme>
